import React from "react";
import MessageCard from "./Message";

const MessageList = ({ messages }) =>
  messages && messages.length > 0 ? (
    <div className="mb-5 d-flex flex-column align-items-center gap-3">
      {messages.map((msg, idx) => (
        <div key={idx} style={{ width: "100%", maxWidth: 350 }}>
          <MessageCard
            name={msg.name}
            country={msg.country}
            city={msg.city}
            message={msg.message}
            date={msg.timestamp}
          />
        </div>
      ))}
    </div>
  ) : null;

export default MessageList;
